import React, { useEffect, useRef, useState } from 'react';

/**
 * Areas of Concern / Press Progress cards — same ⋯ menu as real boards
 * so they can be filed into a folder or archived.
 */
const THEMES = {
  areas_of_concern: {
    name: 'Areas of Concern',
    blurb: 'Weekly schedule-update email · Assumptions / Needs or Areas of Concern · week history',
    icon: '✉',
    border: '#c2410c',
    iconBg: '#c2410c',
    cardBg: 'linear-gradient(160deg, #fff7ed 0%, #fff 55%)',
    hoverShadow: '0 4px 14px rgba(194,65,12,0.18)',
  },
  press_progress: {
    name: 'Press Progress',
    blurb: 'Overall + last week gain · MECH / ELEC / PIPE / Punch / TCCC · live from P6',
    icon: '▦',
    border: '#0f766e',
    iconBg: '#0f766e',
    cardBg: 'linear-gradient(160deg, #ecfdf5 0%, #fff 55%)',
    hoverShadow: '0 4px 14px rgba(15,118,110,0.2)',
  },
};

const GaCompanionCard = ({
  cardKey,
  folders = [],
  archived = false,
  isDragging,
  isOver,
  onOpen,
  onDragStart,
  onDragOver,
  onDragLeave,
  onDrop,
  onDragEnd,
  onArchive,
  onRestore,
  onMoveToFolder,
}) => {
  const theme = THEMES[cardKey] || THEMES.areas_of_concern;
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const close = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [menuOpen]);

  return (
    <div
      draggable
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onClick={onOpen}
      style={{
        background: theme.cardBg,
        border: isOver ? `2px solid ${theme.border}` : `2px solid ${theme.border}`,
        borderRadius: 12,
        padding: 12,
        cursor: 'pointer',
        minHeight: 180,
        display: 'flex',
        flexDirection: 'column',
        opacity: isDragging ? 0.55 : archived ? 0.88 : 1,
        boxShadow: isOver ? '0 0 0 3px rgba(15,118,110,0.15)' : undefined,
      }}
      onMouseEnter={(e) => { if (!isDragging) e.currentTarget.style.boxShadow = theme.hoverShadow; }}
      onMouseLeave={(e) => { if (!isOver) e.currentTarget.style.boxShadow = 'none'; }}
    >
      <div style={{
        flex: 1, borderRadius: 8, background: theme.iconBg, color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 42, marginBottom: 10,
      }}>{theme.icon}</div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, minWidth: 0, flex: 1 }}>
          <span
            title="Drag onto a folder"
            onClick={(e) => e.stopPropagation()}
            style={{
              cursor: 'grab', color: '#94a3b8', fontSize: 14, lineHeight: 1.2,
              letterSpacing: -1, userSelect: 'none', paddingTop: 2, flexShrink: 0,
            }}
            aria-hidden
          >⠿</span>
          <strong style={{ fontSize: 15 }}>{theme.name}</strong>
        </div>
        <div ref={menuRef} style={{ position: 'relative', flexShrink: 0 }} onClick={(e) => e.stopPropagation()}>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            title="Board actions"
            style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#64748b', fontSize: 18, lineHeight: 1, padding: '0 2px' }}
          >⋯</button>
          {menuOpen && (
            <div style={{
              position: 'absolute', right: 0, top: '100%', zIndex: 20, minWidth: 188,
              background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8,
              boxShadow: '0 8px 24px rgba(15,23,42,0.12)', padding: 6,
            }}>
              {archived ? (
                <button type="button" onClick={() => { setMenuOpen(false); onRestore(); }} style={menuBtn}>
                  Restore
                </button>
              ) : (
                <button type="button" onClick={() => { setMenuOpen(false); onArchive(); }} style={menuBtn}>
                  Archive
                </button>
              )}
              {!archived && (
                <div style={{ borderTop: '1px solid #f1f5f9', margin: '6px 0', paddingTop: 6 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', padding: '2px 8px 4px' }}>Move to</div>
                  <button type="button" onClick={() => { setMenuOpen(false); onMoveToFolder(null); }} style={menuBtn}>
                    Unfiled
                  </button>
                  {folders.map((f) => (
                    <button
                      key={f.id}
                      type="button"
                      onClick={() => { setMenuOpen(false); onMoveToFolder(f.id); }}
                      style={menuBtn}
                    >
                      {f.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{theme.blurb}</div>
      {archived && <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 10 }}>Archived</div>}
    </div>
  );
};

const menuBtn = {
  display: 'block',
  width: '100%',
  textAlign: 'left',
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  padding: '7px 8px',
  borderRadius: 6,
  fontSize: 13,
  color: '#334155',
};

export default GaCompanionCard;
